export default "__VITE_ASSET__CGLF_B_z__"